module.exports = __webpack_public_path__ + "img/cash_nl50.b7c12db4.png";